<template>
  <div id="el-index-dody">
    <template>
      <el-carousel class="el-sindex-banner" trigger="click" height="660px" arrow="always" :interval="20000">
        <el-carousel-item>
          <img src="../../../static/images/index/sindex_banner1.jpg" />
          <div class="sindex-text">
            <h2>安全、快捷、高效</h2>
            <h1>中欧班列运踪实时查询平台</h1>
            <h2>建立的铁路集装箱多式联运生态体系</h2>
            <div class="sindex-input">
              <el-input
                placeholder="请输入箱号进行查询 (例如: CICU1936971)"
                v-model="gpsInput"
                clearable
                @keypress.enter.native="sinSerch(gpsInput)">
              </el-input>
              <el-button type="primary" @click="sinSerch(gpsInput)">立即查询</el-button>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../../static/images/index/sindex_banner2.jpg" />
          <div class="sindex-text sindex-gps">
            <h3>为客户提供可视化端到端服务</h3>
            <h2>GPS可视化智能终端</h2>
            <h3>多链路赋能，实现跨境进出口解决方案</h3>
            <el-button type="primary" @click="sinProduct">了解详情</el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </template>
    <div class="el-wit-teen">
      <ul class="sindex-service">
        <li v-for="(item, index) in Science">
          <div class="sindex-service-l">
            <i class="iconfont" :class="item.icon"></i>
          </div>
          <div class="sindex-service-r">
            <h4>{{item.tit}}</h4>
            <p>{{item.text}}</p>
          </div>
        </li>
      </ul>
      <div class="el-lc-bz el-waper">
        <div class="sindex-description-l">
          <div class="sindex-description-l-title">
            <blockquote></blockquote>
            <h3>及时在线追踪货物<br />查看定位，完善的铁路服务</h3>
          </div>
          <div class="sindex-description-l-text">
            <p v-for="item in gpsSub"><span></span>{{item.txt}}</p>
          </div>
        </div>
        <div class="sindex-description-r">
          <img src="static/images/index/sindex_desc.jpg">
        </div>
      </div>
    </div>
    <div class="sindex-step">
      <div class="sindex-step-inner">
        <h3>轻松四步，即可查询</h3>
        <div class="sindex-step-inner-img">
          <img src="../../../static/images/index/sindex_step_num.png">
        </div>
        <el-button type="primary" class="sindex-submit" @click="sinResg">试用一下</el-button>
      </div>
    </div>
    <div class="sindex-advantage">
      <div class="sindex-advantage-inner">
        <h3>产品特性</h3>
        <h4>定位精准，及时报告到达目的地所需距离，适用于各种物流运输</h4>
        <div class="product-advantage-list">
          <div class="product-advantage-list-icon" v-for="item in special">
            <div class="advantage-item" v-for="items in item.listL">
              <div class="advantage-l">
                <i class="iconfont" :class="items.icon"></i>
              </div>
              <div class="advantage-r">
                <h3>{{items.title}}</h3>
                <p>{{items.txt}}</p>
              </div>
            </div>
          </div>
          <div class="product-advantage-list-img">
            <img src="../../../static/images/product/product_mashine.png" alt="产品图片">
          </div>
          <div class="product-advantage-list-icon" v-for="item in special">
            <div class="advantage-item" v-for="items in item.listR">
              <div class="advantage-l">
                <i class="iconfont" :class="items.icon"></i>
              </div>
              <div class="advantage-r">
                <h3>{{items.title}}</h3>
                <p>{{items.txt}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 后台服务 -->
    <div class="el-wit-teen">
      <div class="sindex-admin">
        <div class="sindex-admin-text">
          <div class="sindex-admin-text-l">
            <img src="../../../static/images/index/sindex-admin.jpg">
          </div>
          <div class="sindex-admin-text-r">
            <h3>后台服务</h3>
            <h4>智能定位终端与运踪服务平台无缝连接，高并发准确实时追踪</h4>
            <div class="admin-txt" v-for="item in admin">
              <i class="iconfont icon-success-fill"></i>
              <p>{{item.txt}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 团队 -->
    <div class="sindex-team">
      <div class="el-wit-teen">
        <h3>专业团队</h3>
        <h4>以节约客户物流成本，人力成本，提升客户物流能力为宗旨</h4>
        <div class="sindex-team-item">
          <div class="sindex-team-item-icon" v-for="item in team">
            <i class="iconfont" :class="item.icon"></i>
            <span>{{item.txt}}</span>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
  import Footer from "../global/footer";
  export default {
    name: "Sindex",
    data() {
      return {
        gpsInput: "", // 集装箱号查询
        Science: [{
          id: 1,
          icon: "icon-writing",
          tit: "运输方案制定",
          text: "根据货物所在地、货物体量、交期等，结合运价、时效，为货主量身打造专业化的跨国运输方案。"
        }, {
          id: 2,
          icon: "icon-sorting",
          tit: "起运地/目的地延伸服务",
          text: "可为客户提供起运地提货，入仓，分拣，报关，目的地清关，派送等增值服务。"
        }, {
          id: 3,
          icon: "icon-packaging",
          tit: "货物动态查询",
          text: "设备监控，及时查询货物运输动态信息。"
        }],

        gpsSub: [{
          id: 1,
          txt: "搭配GPS设备，可视化运踪系统，及时更新",
        }, {
          id: 2,
          txt: "实时位置查询，尽在掌握",
        }, {
          id: 3,
          txt: "行驶轨迹绘制，路径清晰",
        }, {
          id: 4,
          txt: "抵达关口识别，科技智能",
        }, {
          id: 5,
          txt: "运踪邮件推送，货物动态及时掌握",
        }],

        special: [{
          listL: [{
            id: 1,
            icon: "icon-dongtai",
            title: "多种通信",
            txt: "支持多种网络接入"
          }, {
            id: 2,
            icon: "icon-map",
            title: "LBS定位",
            txt: "LBS基站三角定位，更快更准确"
          }, {
            id: 3,
            icon: "icon-iconset0250",
            title: "电量显示",
            txt: "实时显示剩余电量"
          }, {
            id: 4,
            icon: "icon-eletrical",
            title: "反复充电",
            txt: "内置电池供电，节能环保"
          }],

          listR: [{
            id: 5,
            icon: "icon-quick",
            title: "续航时间长",
            txt: "内置6000毫安电池，可续航180天以上"
          }, {
            id: 6,
            icon: "icon-notice",
            title: "位置及时上报",
            txt: "上报间隔可调，及时获取距目的距离"
          }, {
            id: 7,
            icon: "icon-tool-hardware",
            title: "拆装便捷",
            txt: "采用强力魔术贴设计，满足恶劣环境拆装"
          }, {
            id: 8,
            icon: "icon-ipad",
            title: "机身轻薄",
            txt: "86g净重，20mm厚度，小巧不占空间"
          }]
        }],

        admin: [{
          id: 1,
          txt: "中欧班列专业化订制管理平台，灵活添加线路。"
        }, {
          id: 2,
          txt: "管理设备注册、激活、运行轨迹及状态停用等。"
        }, {
          id: 3,
          txt: "保护客户数据资产，支持远程部署，支持WEB API协议对接。"
        }, {
          id: 4,
          txt: "支持远程对终端上报频率进行配置,上报时间间隔灵活可调。"
        }, {
          id: 5,
          txt: "管理员权限分三级管理，支持设备分组管理，支持分类查询。"
        }],

        team: [{
          id: 1,
          icon: "icon-Customermanagement",
          txt: "专业团队全程服务"
        }, {
          id: 2,
          icon: "icon-earth",
          txt: "网络完善、多地布局"
        }, {
          id: 3,
          icon: "icon-shouhuoicon",
          txt: "端到端供应链一体化"
        }, {
          id: 4,
          icon: "icon-electronics",
          txt: "智慧进出口管理"
        }]
      }
    },
    methods: {
      //点击传值进行箱号搜索
      sinSerch(val) {
        let routeData = this.$router.resolve({
          name: "Main",
          query: {
            val: val,
          },
        });
        window.open(routeData.href, "_blank");
      },

      //跳转产品页
      sinProduct() {
        this.$router.push({
          path: "/Product"
        })
      },

      //跳转登录页
      sinResg() {
        this.$router.push({
          path: "/Main"
        })
      }
    },

    components: {
      Footer,
    },

    mounted() {
      let lang = navigator.language || navigator.userLanguage
      if(document.cookie.indexOf('__51laig__=1') === -1) {
        return;
      } else {
      //  判断浏览器语言是否为英文
        if(lang === 'zh-CN') {
          return;
        }else {
          this.$confirm('Do you need to visit an English site', 'Notice', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            type: 'info'
          }).then((res) => {
            if(res === 'confirm') {
              window.location.href = 'http://gps.jagich.com/yz-en'
            }
          }).catch(() => {
            return
          })
        }
      }
    }
  };
</script>
<style scoped>
  .el-menu--horizontal>.el-menu-item.is-active {
    color: #409EFF !important;
  }
</style>
<style scoped>
  @import "./sind/sind.css";
  @import "../../../static/font/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/sindex/sindex.vue